module.exports = __webpack_public_path__ + "img/icon-specific.990aa4e8.svg";